import React from 'react';
import { hdfcConfig } from '../demoConfigs';
import ReusableDemoPage from "../ReusableDemoPage";
const HdfcDemo = () => {
  return <ReusableDemoPage config={hdfcConfig} />;
};

export default HdfcDemo;